import React from 'react';
import { generateIcon } from '../generateIcon';

export const IconClose = generateIcon({
  name: 'Close',
  path: (
    <path d="M25.707 24.292a1.002 1.002 0 0 1-.324 1.632 1 1 0 0 1-1.09-.217L16 17.414l-8.292 8.293a1 1 0 1 1-1.415-1.415L14.586 16 6.293 7.707a1 1 0 0 1 1.415-1.415L16 14.586l8.293-8.294a1 1 0 1 1 1.415 1.415L17.413 16l8.293 8.292Z" />
  ),
});
